module.exports = __webpack_public_path__ + "assets/img/sign_in_ok.ffe590ef.png";